<template>
  <div>
    <el-alert
      v-if="error"
      title="An error happened. Either a bad edit link was provided or the service is unavailable."
      type="error">
    </el-alert>
    <el-alert
      v-if="successMsg && !error"
      title="Code updated!"
      type="success">
    </el-alert>
    <h2><em>Edit your code</em></h2>
    <div class="top-block">
      <div>
        <span class="separaters">nin.codes/{{this.title}}</span>
      </div>
      <el-input id="first" class="code-box" placeholder="XXXX" maxlength=4 v-model="first"></el-input>
      <div class="separaters">-</div>
      <el-input id="second" class="code-box" placeholder="XXXX" maxlength=4 v-model="second"></el-input>
      <div class="separaters">-</div>
      <el-input id="third" class="code-box" placeholder="XXXX" maxlength=4 v-model="third"></el-input>
      <div>
        <el-button @click=submitUpdate() type="primary">Update</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../services/axios';

export default {
  name: "UpdateCode",
  data() {
    return {
      title: '',
      key: '',
      first: '',
      second: '',
      third: '',
      successMsg: '',
      error: false,
    };
  },
  created() {
    this.title = this.$route.params.title;
    this.key = this.$route.params.key;

    axios.get(this.title)
      .then((resp) => {
        switch (resp.status) {
          case 200:
            this.first = resp.data.code.substring(0,4);
            this.second = resp.data.code.substring(4,8);
            this.third = resp.data.code.substring(8,12);
            break;
          default:
            this.code = 'unexpected response';
        }
      })
      .catch((rej) => {
        this.error = true;
        switch (rej.response.status) {
          case 404:
            this.code = 'Create this short link?';
            break;
          case 400:
            this.code = 'something happened';
            break;
          default:
            this.error = 'unexpected response';
        }
      });
  },
  methods: {
    submitUpdate() {
      axios.patch(`/update/${this.title}/${this.key}`, {
        code: `${this.first}${this.second}${this.third}`,
      })
        // eslint-disable-next-line
        .then((resp) => {
          this.successMsg = 'update';
        })
        // eslint-disable-next-line
        .catch((err) => {
          this.error = true;
        });
    },
  },
}
</script>
